import { DefaultEventsMap } from '@socket.io/component-emitter'
import { Socket } from 'socket.io-client'
import {
  resetCallData,
  setCallData,
  setFormData,
  setHangup,
  setIsRinging,
  setLastExpertTalked,
  setRingingData,
  setSelectedCustomer,
  setShowCallRegistration,
} from 'store/slice/call-detail/call-detail.slice'
import { SetCallDataPayloadType } from 'store/slice/call-detail/types'
import { setUserInfo } from 'store/slice/logged-in-user/logged-in-user.slice'
import { LoggedInUserStateType } from 'store/slice/logged-in-user/types/loggedInUserState.type'
import { SetUserInfoPayloadType } from 'store/slice/logged-in-user/types/setUserInfoPayload.type'
import { AppDispatch } from 'store/store'

const CallcenterFixedUsers = [
  'DCRM\\n.soufiloo',
  'DCRM\\darabi',
  'DCRM\\h.safaverdi',
  'DCRM\\m.yosefi',
  'DCRM\\Abdolahipor',
  'DCRM\\H.Hojati',
]

export const isFixedUser = (dcrm?: string | null) => {
  if (dcrm) {
    return CallcenterFixedUsers.map((item) =>
      item.toLocaleLowerCase()
    ).includes(dcrm.toLocaleLowerCase())
  }
  return false
}

export const setSocketListeners = (
  socket: Socket<DefaultEventsMap, DefaultEventsMap>,
  dispatch: AppDispatch,
  loggedInUser: LoggedInUserStateType
) => {
  socket.emit('login', (userInfo: SetUserInfoPayloadType) => {
    console.log('login as extension ', userInfo?.userPhone)
    if (userInfo) {
      dispatch(setUserInfo(userInfo))
    }
  })

  socket?.on('hangup', () => {
    dispatch(setHangup(true))
  })

  function dispatchSelectedCustomerIfNotNew(event: SetCallDataPayloadType) {
    if (!event.isNewCustomer) {
      if (event.contactId) {
        dispatch(
          setSelectedCustomer({
            name: event.contactName,
            id: event.contactId,
            type: 'contact',
          })
        )
      } else if (event.accountId) {
        dispatch(
          setSelectedCustomer({
            name: event.accountName,
            id: event.accountId,
            type: 'account',
          })
        )
      } else if (event.leadId) {
        dispatch(
          setSelectedCustomer({
            name: event.leadName,
            id: event.leadId,
            type: 'lead',
          })
        )
      }
    }
  }

  const getCallerName = (event: SetCallDataPayloadType) => {
    if (event.leadName) {
      return event.leadName
    }
    let callerName = ''
    if (event.contactName) {
      callerName += event.contactName + ' '
    }
    if (event.contactName && event.accountName) {
      callerName += 'از شرکت '
    }
    if (event.accountName) {
      callerName += event.accountName
    }
    if (!callerName) {
      callerName = 'مشتری جدید'
    }
    return callerName
  }

  if (loggedInUser.id) {
    socket.on('ringing', (event: SetCallDataPayloadType) => {
      if (event) {
        const callerName = getCallerName(event)
        console.log('ringing: ', { ...event, callerName })
        dispatch(setRingingData({ ...event, callerName }))
      }
    })

    socket.on('pickup', (event) => {
      dispatch(setHangup(false))
      dispatch(setIsRinging(false))
      const isFixedCallcenterUser = isFixedUser(loggedInUser?.userDomain)
      console.log('isfixed', isFixedCallcenterUser, loggedInUser)

      if (event) {
        if (
          loggedInUser.teamName === 'کال سنتر' ||
          loggedInUser.teamName === 'امور مشتریان' ||
          loggedInUser.teamName === 'طراحی محصول' ||
          // loggedInUser.userPositionLevel === 'کارشناس فروش' ||
          isFixedCallcenterUser
        ) {
          dispatch(resetCallData())
          dispatchSelectedCustomerIfNotNew(event)
          const callerName = getCallerName(event)
          const callData = { ...event, ...event.callDetail, callerName }
          console.log('pickup2: ', callData)
          dispatchSelectedCustomerIfNotNew(event)
          dispatch(setCallData(callData))
          dispatch(setLastExpertTalked(callData?.callDetail?.lastExpertTalked))
          dispatch(
            setFormData({
              leadId: callData.leadId,
              leadName: callData.leadName,
              preLeadName: callData.preName?.value,
            })
          )
          dispatch(setShowCallRegistration(true))
        }
      }
    })
  }

  // for test
  // const callData = {
  //   accountName: null,
  //   contactName: null,
  //   leadName: 'نیما',
  //   accountId: null,
  //   contactId: null,
  //   leadId: '4a2ef10f-9af7-ec11-8b54-005056b214b1',
  //   preName: {
  //     label: 'مهندس',
  //     value: 100000006,
  //   },
  //   invoiceCount: 0,
  //   isVIP: false,
  //   isNewCustomer: false,
  //   phoneNumber: '09389826331',
  //   quoteCount: 0,
  //   phoneCallId: '9fa10df5-aaf7-ec11-8b54-005056b214b1',
  //   callDetail: {
  //     rawId: '1656507406.75902',
  //     id: '1656507406',
  //     source: '09389826331',
  //     durationInSec: null,
  //     destination: '535',
  //     direction: 'INCOMING',
  //     startTime: '2022-06-29T12:56:13.605Z',
  //     endTime: null,
  //     isHangup: false,
  //     isCallPickup: false,
  //     counter: 0,
  //     phoneCallId: '9fa10df5-aaf7-ec11-8b54-005056b214b1',
  //     rings: {
  //       '535': 'a1a10df5-aaf7-ec11-8b54-005056b214b1',
  //     },
  //     voiceUrl:
  //       '2022/06/29/external-535-9389826331-20220629-172646-1656507406.75902.wav',
  //     transferVoiceUrl: null,
  //     transferHistory: [
  //       {
  //         transferTime: 1,
  //         extension: '535',
  //         domainName: 'DCRM\\n.soufiloo',
  //         fullName: 'نیما صوفی لو',
  //         teamName: 'امور مشتریان',
  //         userPosition: 'کارشناس توسعه محصول',
  //         userPositionLevel: 'کارشناس',
  //         phoneCallId: '9fa10df5-aaf7-ec11-8b54-005056b214b1',
  //         imageUrl:
  //           'https://contents.ahanonline.com/profile/DCRM%5Cn.soufiloo.jpg',
  //       },
  //     ],
  //   },
  //   callerName: 'نیما',
  // }
  // dispatch(
  //   setFormData({
  //     leadId: callData.leadId,
  //     leadName: callData.leadName,
  //     preLeadName: callData.preName?.value,
  //   })
  // )
  // dispatch(setCallData(callData as any))
  // dispatch(
  //   setRingingData({
  //     accountName: null,
  //     contactName: null,
  //     leadName: 'نیما',
  //     accountId: null,
  //     contactId: null,
  //     leadId: '4a2ef10f-9af7-ec11-8b54-005056b214b1',
  //     preName: {
  //       label: 'مهندس',
  //       value: 100000006,
  //     },
  //     invoiceCount: 0,
  //     isVIP: false,
  //     isNewCustomer: false,
  //     phoneNumber: '09389826331',
  //     quoteCount: 0,
  //     phoneCallId: '9fa10df5-aaf7-ec11-8b54-005056b214b1',
  //     callerName: 'نیما',
  //   } as any)
  // )
}

export default setSocketListeners
